import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const DeleteIcon = (props: SvgProps) => (
    <Svg
    
    width={14}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      fill="#EB2027"
      d="M2.66 15.846c-.426 0-.79-.15-1.09-.45-.299-.299-.449-.662-.449-1.088V2.046H.137v-.92h3.892V.385h5.954v.738h3.892v.923h-.984v12.266c0 .43-.149.793-.445 1.09a1.486 1.486 0 0 1-1.094.444H2.66Zm9.308-13.8H2.044v12.262a.6.6 0 0 0 .173.442.599.599 0 0 0 .443.173h8.692a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423V2.046ZM4.883 12.942h.923V4.018h-.923v8.924Zm3.323 0h.923V4.018h-.923v8.924Z"
    />
  </Svg>
)
export default DeleteIcon
